import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
    Page,
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
} from '../../components';
import { TopbarContainer } from '../../containers';
import css from './LandingPageMatchingAlgorithm.css';
import {
    SectionHero,
    SectionHowItWorks,
    SectionExistingCategories,
    SectionMatchingCriteria,
    SectionFAQ,
} from '../LandingPage/sectionsMatchingAlgorithm';
import { SectionCommunityFeedbacks } from '../LandingPage/sections';
import { SectionJoinUs } from '../LandingPage/sections';
import { getLpSchemaObj, facebookImages, twitterImages } from '../LandingPage/common/helpers';
import { jsonLd } from './json-ld';

export const MatchingAlgorithmLandingPageComponent = ({ history, scrollingDisabled }) => {
    const schemaTitle = 'Matching für Pferdemenschen und Pferde | HorseDeal';
    const schemaDescription =
        'Hier erfährst Du mehr über den Matching-Algorithmus für das perfekte Match von Pferdemensch und Pferd. Mehr erfahren.';

    return (
        <Page
            scrollingDisabled={scrollingDisabled}
            contentType="website"
            description={schemaDescription}
            title={schemaTitle}
            facebookImages={facebookImages}
            twitterImages={twitterImages}
            schema={{
                ...getLpSchemaObj(schemaTitle, schemaDescription),
                '@context': jsonLd['@context'],
                '@type': jsonLd['@type'],
                mainEntity: jsonLd['mainEntity'],
            }}
        >
            <LayoutSingleColumn>
                <LayoutWrapperTopbar>
                    <TopbarContainer />
                </LayoutWrapperTopbar>
                <LayoutWrapperMain
                    className={css.layout}
                    blobBackground
                    blobProps={{
                        xDistance: 20,
                        baseWidth: 760,
                    }}
                >
                    <main className={css.container}>
                        <SectionHero />
                        <SectionHowItWorks />
                        <SectionExistingCategories history={history} />
                        <SectionMatchingCriteria />
                        <SectionCommunityFeedbacks history={history} />
                        <SectionFAQ />
                        <SectionJoinUs history={history} />
                    </main>
                </LayoutWrapperMain>
                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSingleColumn>
        </Page>
    );
};

const { bool, object, array } = PropTypes;

MatchingAlgorithmLandingPageComponent.propTypes = {
    scrollingDisabled: bool.isRequired,

    // from withRouter
    history: object.isRequired,
    location: object.isRequired,

    // from injectIntl
    intl: intlShape.isRequired,
};

const mapStateToProps = ({ UI }) => ({
    scrollingDisabled: isScrollingDisabled({ UI }),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671

const MatchingAlgorithmLandingPage = compose(
    withRouter,
    connect(mapStateToProps),
    injectIntl
)(MatchingAlgorithmLandingPageComponent);

export default MatchingAlgorithmLandingPage;
